"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _common = require("../../../components/core/common");
var _core = require("../../../services/core");
var _form = require("../../../components/core/form");
var _siteAddress = _interopRequireDefault(require("./site-address"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Style

// Core

const {
  Input
} = _form._Form;
var _default = () => {
  const [sites, setSites] = (0, _react.useState)(1);
  const site = function (className) {
    let index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
      className: `col-12 p-2 m-0 mt-2 pb-3 ${className}`,
      key: `site_${index}`
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
      className: "py-1 px-3"
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
      className: "col-lg-4 col-md-5"
    }, (0, _core._translate)('structurereferencementapp_site_name'), "*:"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
      className: "col-7"
    }, /*#__PURE__*/_react.default.createElement(Input, {
      name: `sites[${index}].name`,
      type: "text",
      label: null
    }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
      className: "py-1 px-3"
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
      className: "col-lg-4 col-md-5"
    }, (0, _core._translate)('structurereferencementapp_site_address'), "*:"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
      className: "col-7"
    }, /*#__PURE__*/_react.default.createElement(_siteAddress.default, {
      name: `sites[${index}].address`
    }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
      className: "py-2 px-3"
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
      className: "col-lg-4 col-md-5"
    }, (0, _core._translate)('structurereferencementapp_site_capacity'), "*:"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
      className: "col-7"
    }, /*#__PURE__*/_react.default.createElement(Input, {
      name: `sites[${index}].capacity`,
      type: "number",
      label: null
    }))));
  };
  const sitesGenerator = () => {
    const sitesApp = [];
    for (let i = 0; i < sites; i++) {
      sitesApp.push(site(i % 2 === 0 ? 'bg-light' : '', i));
    }
    return sitesApp;
  };
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "m-0 px-0 py-0"
  }, sitesGenerator(), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-12 d-flex justify-content-end mt-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
    color: "danger",
    size: "sm",
    className: "btn-wever-red px-3 py-1",
    onClick: () => setSites(sites + 1)
  }, ' ', /*#__PURE__*/_react.default.createElement(_common._Icon, {
    name: "plus-circle",
    className: "mx-1"
  }), (0, _core._translate)('structurereferencementapp_add_site'))));
};
exports.default = _default;